<div class="telr-return">
  @if (isProcessing) {
    <mat-spinner [diameter]="40"></mat-spinner>
    <h2 class="telr-return__title">{{ 'telr_payment_redirecting' | translate }}</h2>
  }

  @if (!isProcessing) {
    <h2 class="telr-return__title">{{ statusTitleKey | translate }}</h2>
    <p class="telr-return__message">{{ statusMessageKey | translate }}</p>
    <p class="telr-return__hint">
      {{ (isPopupReturn ? 'telr_payment_close_window_hint' : 'telr_payment_continue_to_plans') | translate }}
    </p>
    <button type="button"
      class="telr-return__close"
      (click)="onPrimaryAction()">
      {{ primaryActionKey | translate }}
    </button>
  }
</div>
